import { useSelector } from 'react-redux'
import { Page } from '../../shared/Routing'
import BotHeadSpin from '../../shared/Loading/BotHeadSpin'
import { selectHomeLoading } from '../../../store/selectors/home'
import TuneValueForm from './TuneValueForm'

import styles from './TuneValueContainer.module.scss'

export const TuneValueContainer = () => {
  const loading = useSelector(selectHomeLoading)
  return (
    <Page>
      <Page.Body className={styles.body}>{loading ? <BotHeadSpin panelSpacing /> : <TuneValueForm />}</Page.Body>
    </Page>
  )
}
